import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Router, Route, Switch } from 'react-router-dom';
import { AsyncComponent } from '@unitedtraders/application-bootstrapper';
import { asyncImport } from './shared/utils';
import PageLoading from './blocks/pageLoading/PageLoading';
import { Layout } from './blocks/layout/Layout';

import NotFoundPage from './pages/404/NotFoundPage';
import { passApplication } from '@unitedtraders/application-bootstrapper';
import { compose } from 'recompose';
const LazyComponent = ({ modulePromise, ...props }) => (
  <AsyncComponent
    {...props}
    LoadingView={PageLoading}
    getComponent={asyncImport(() => modulePromise.then(module => module.default))}
  />
);

const enhance = compose(passApplication);

class RoutesRaw extends Component {
  static contextTypes = {
    window: PropTypes.object
  };

  static propTypes = {
    history: PropTypes.object.isRequired
  };

  render() {
    const { history } = this.props;

    return (
      <Router history={history}>
        <Layout>
          <Switch>
            <Route
              path="/trading"
              component={props => (
                <LazyComponent
                  {...props}
                  modulePromise={import(/* webpackChunkName: "trading" */
                  './trading/routes')}
                />
              )}
            />
            <Route path="*" component={NotFoundPage} />
          </Switch>
        </Layout>
      </Router>
    );
  }

  componentDidMount() {
    this.historyUnlisten = this.props.history.listen(
      (_, action) => action !== 'POP' && this.scrollToTop()
    );
  }

  componentWillUnmount() {
    this.historyUnlisten();
  }

  scrollToTop() {
    const { window } = this.context;
    if (window) {
      window.scrollTo(0, 0);
    }
  }
}

export const Routes = enhance(RoutesRaw);



// WEBPACK FOOTER //
// ./src/routes.js